import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import TemplatesIndexCard from '../../Templates/TemplatesIndexCard';

export default function TemplatePage(props) {
	console.log(props);

	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.templates')}
				category={I18n.t('admin.communications')}
			/>
			<TemplatesIndexCard
				get_communication_template_endpoint={
					props.get_communication_template_endpoint
				}
				communication_templates_list_endpoint={
					props.communication_templates_list_endpoint
				}
				data={[
					{
						id: 1,
						template_name: 'Invitation to Sign Up Email',
						updated_at: '12/12/2023'
					},
					{
						id: 2,
						template_name: 'Follow-Up Email',
						updated_at: '12/12/2023'
					},
					{
						id: 3,
						template_name: 'Some Other Email',
						updated_at: '12/12/2023'
					}
				]}
			/>
		</div>
	);
}
